import { LumpSumAmountsCoveredOptions } from 'app/constants/configuration/lumpSumAmountsCoveredOptions'

export const getLumpSumAmountsCoveredOptionsName = (
  lumpSumAmountsCoveredOptions: LumpSumAmountsCoveredOptions,
  translate: (string) => string,
): string => {
  const text: string =
    LumpSumAmountsCoveredOptions[lumpSumAmountsCoveredOptions]
  return translate(`lumpSumAmountsCoveredOptions.${text}`)
}
